






































































import { Component, Vue } from "vue-property-decorator";
import ChannelList from "@/components/overlay/components/ChannelList.vue";
import { Action, Getter, Mutation } from "vuex-class";
import {
  OverlayAction,
  OverlayGetter,
  OverlayMutation,
  OverlaySection
} from "@/components/overlay/types";
import { Namespace } from "@/store/types";
import CenterMenuBase from "@/components/overlay/components/centerMenu/CenterMenuBase.vue";
import SpatialNavigation from "spatial-navigation-js";
import apiStorageInterface from "@/services/apiStorageInterface";
import { ChannelChangeGetter } from "@/components/channelChange/types";
import { Episode, Movie, MyChannel } from "@/services/apiService/api.types";
import EpgNext from "@/components/overlay/components/rightMenu/ContentNext.vue";
import EpgList from "@/components/overlay/components/rightMenu/OverlayContentList.vue";
import LockIcon from "@/assets/svg/svg-settings/LockIcon.vue";
import ChannelsIcon from "@/assets/svg/svg-home/01-channels.vue";
import { VodPageAction } from "@/components/VoD/types";

@Component({
  components: {
    LockIcon,
    EpgList,
    EpgNext,
    CenterMenuBase,
    ChannelList,
    ChannelsIcon
  }
})
export default class OverlayBase extends Vue {
  @Action(OverlayAction.UpdateOverlayStatus, {
    namespace: Namespace.Overlay
  })
  closeOverlay!: () => void;

  @Action(OverlayAction.UpdateOverlayStatus, { namespace: Namespace.Overlay })
  updateOverlayStatus!: (overlaySectionStatus: OverlaySection) => void;

  @Action(VodPageAction.UpdateClosePlayer, {
    namespace: Namespace.Vod
  })
  updateClosePlayer!: (status: boolean) => void;

  @Action(OverlayAction.UpdateActiveVodItemProgressDuration, {
    namespace: Namespace.Overlay
  })
  updateActiveVodItemProgressDuration!: (
    playbackTimestamp: number | null
  ) => void;

  @Mutation(OverlayMutation.SetActiveVodItem, {
    namespace: Namespace.Overlay
  })
  setActiveVodItem!: (vod: Movie | Episode | null) => void;

  @Mutation(OverlayMutation.SetActiveVodItemDuration, {
    namespace: Namespace.Overlay
  })
  setActiveVodItemDuration!: (duration: number | null) => void;

  @Getter(OverlayGetter.GetOverlayOpen, {
    namespace: Namespace.Overlay
  })
  getOverlayOpen!: OverlaySection;

  @Getter(ChannelChangeGetter.GetChannelId, {
    namespace: Namespace.ChannelChange
  })
  getChannelId!: number;

  @Getter(OverlayGetter.GetActiveVodItem, {
    namespace: Namespace.Overlay
  })
  getActiveVodItem!: Movie | Episode | null;

  overlayCloseTimer = 0;
  channelList: MyChannel[] = [];

  async mounted(): Promise<void> {
    this.overlayCloseReset();
    if (this.$route.path.search("/vod") < 0) {
      this.channelList = await apiStorageInterface.fetchCustomChannelList();
    }
    SpatialNavigation.resume();
  }

  closeAndGoBack(): void {
    this.closeOverlay();
    if (this.$route.path.search("vod") < 0) {
      this.$router.back();
    }
    if (this.$route.path.search("vod")) {
      this.updateClosePlayer(false);
      this.setActiveVodItem(null);
      this.updateActiveVodItemProgressDuration(null);
      this.setActiveVodItemDuration(null);
    }
  }

  get imgPlaceholder(): string {
    return require("/src/assets/images/square-image-placeholder.jpg");
  }

  get lockIconPurple(): string {
    return require("/src/assets/svg/svg-settings/02-lock-icon-purple.svg");
  }

  get arrowLeft(): string {
    return require("/src/assets/svg/left.svg");
  }

  //checks if any overlaySection is open
  get overlayOpen(): boolean {
    return this.getOverlayOpen !== "";
  }

  get isChannelLocked(): boolean {
    for (let i = this.channelList.length - 1; i >= 0; i--) {
      if (
        this.channelList[i].id === this.getChannelId &&
        this.channelList[i].parentalLock
      ) {
        return true;
      }
    }

    return false;
  }

  get playbackItemImg(): string | undefined {
    let playbackItemImg = undefined;
    if (this.channelList.length !== 0) {
      for (let i = this.channelList.length - 1; i >= 0; i--) {
        if (this.channelList[i].id === this.getChannelId) {
          playbackItemImg = this.channelList[i].media.url;
        }
      }
    }

    if (this.getActiveVodItem && this.getActiveVodItem.id !== 0) {
      playbackItemImg = this.getActiveVodItem.media?.url;
    }

    return playbackItemImg;
  }

  beforeDestroy(): void {
    SpatialNavigation.resume();
    SpatialNavigation.focus("#playerContainer");
    clearTimeout(this.overlayCloseTimer);
  }

  overlayCloseReset(): void {
    clearTimeout(this.overlayCloseTimer);
    // this is for resetting the timer, storing it in a variable allows me to always work with one instance
    this.overlayCloseTimer = window.setTimeout(() => {
      this.closeOverlay();
    }, 5000);
  }

  openChannelsMenu(): void {
    this.updateOverlayStatus("ChannelList");
  }
}
